export default "__VITE_ASSET__DPK$$SZN__"